import React, { useEffect, useRef, useState } from 'react';
import styled, { keyframes } from 'styled-components';

const OpacityAnimation = keyframes`
  from {opacity: 0};
  to {opacity: 1}
`;

const Container = styled.div`
  position: relative;
  background-color: white;
  animation: ${OpacityAnimation} 0.7s;
`;

const OptionsContainer = ({
  children,
  imageRef
}) => {
  const [height, setHeight] = useState(null);
  const container = useRef();

  useEffect(() => {
    if (imageRef.current) {
      setHeight(imageRef.current.clientHeight);
    }
  }, [imageRef.current]);

  return (
    <Container
      ref={container}
      imageHeight={imageRef.current ? height : null}
    >
      {children}
    </Container>
  );
};

export default OptionsContainer;
